<template>
  <div></div>
</template>

<script>
import Cookies from "js-cookie";
import { redirectToOA } from "@/utils";

export default {
  name: "login",
  data() {
    return {};
  },
  beforeCreate() {
    const _login = Cookies.get("_login");
    if (_login) {
      this.$store
        .dispatch("Login", { _login })
        .then(() => {
          this.$router.push({ path: "/" });
        })
        .catch(() => {});
    } else {
      redirectToOA();
    }
  }
};
</script>
